import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Typography } from "@mui/material";
import { Task } from "@/services/cloudchipr.api";
import { TaskForecastedEOMGroupCell } from "@/components/pages/task-management/components/grid/cell-renderers/TaskForecastedEOMGroupCell";

export const TaskForecastedEOMCellRenderer: FC<
  CustomCellRendererProps<Task>
> = (cell) => {
  const target = cell?.data?.target;
  const node = cell.node as CustomCellRendererProps<Task>["node"];

  const isGroupRow = node.group;

  if (isGroupRow) {
    return <TaskForecastedEOMGroupCell node={node} />;
  }

  if (!target) {
    return null;
  }

  return <Typography variant="body2">{cell.value}</Typography>;
};
